import { useState } from "react";
import {
  SleepQUalityFocus,
  LifeStyleHabit,
  MindAndStress,
  Enviornment,
  SleepSchedule,
} from "@utils/defaultImages";
import { useTranslation } from "react-i18next";
import { CardDetailsModal } from "@components/ui/CardDetailsModal";

const SleepCoachCardView = ({
  dashboard = false,
  sleepCoachStepsData = {},
}) => {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const [data, setData] = useState(false);
  const handleOpen = ({
    label = null,
    icon = null,
    value = null,
    tabColor = null,
    model_value = null,
  }) => {
    setData({
      label,
      icon,
      value,
      tabColor,
      model_value,
    });
    setOpen(true);
  };
  const nutrientData = [
    {
      label: t("Sleep Schedule"),
      key: "Sleep Schedule",
      icon: <SleepSchedule className="w-[28px] h-[28px]" />,
      tabColor: "#F0FFFF",
      value: sleepCoachStepsData?.["Sleep Schedule"],
      model_value: sleepCoachStepsData?.["Sleep Schedule Detail"]
        ? sleepCoachStepsData?.["Sleep Schedule Detail"]
        : sleepCoachStepsData?.["Sleep Schedule"],
    },
    {
      label: t("Environment"),
      key: "focus",
      icon: <Enviornment className="w-[28px] h-[28px]" />,
      tabColor: "#F0FFFF",
      value: sleepCoachStepsData?.["Environment"],
      model_value: sleepCoachStepsData?.["Environment Detail"]
        ? sleepCoachStepsData?.["Environment Detail"]
        : sleepCoachStepsData?.["Environment"],
    },
    {
      label: t("Mind & Stress"),
      key: "awareness",
      icon: <MindAndStress className="w-[28px] h-[28px]" />,
      tabColor: "#F0FFFF",
      value: sleepCoachStepsData?.["Mind & Stress"],
      model_value: sleepCoachStepsData?.["Mind & Stress Detail"]
        ? sleepCoachStepsData?.["Mind & Stress Detail"]
        : sleepCoachStepsData?.["Mind & Stress"],
    },
    {
      label: t("Lifestyle Habits"),
      key: "gentle_return",
      icon: <LifeStyleHabit className="w-[28px] h-[28px]" />,
      tabColor: "#FFF0FB",
      value: sleepCoachStepsData?.["Lifestyle Habits"],
      model_value: sleepCoachStepsData?.["Lifestyle Habits Detail"]
        ? sleepCoachStepsData?.["Lifestyle Habits Detail"]
        : sleepCoachStepsData?.["Lifestyle Habits"],
    },
    {
      label: t("Sleep Quality Focus"),
      key: "duration",
      icon: <SleepQUalityFocus className="w-[28px] h-[28px]" />,
      tabColor: "#FFF0FF",
      value: sleepCoachStepsData?.["Sleep Quality Focus"],
      model_value: sleepCoachStepsData?.["Sleep Quality Focus Detail"]
        ? sleepCoachStepsData?.["Sleep Quality Focus Detail"]
        : sleepCoachStepsData?.["Sleep Quality Focus"],
    },
  ];

  // Card component for reusability
  const Card = ({ label, icon, value, tabColor, model_value }) => (
    <div
      className="cursor-pointer transition-all duration-200 hover:scale-105 py-5 px-2 rounded-[17px] bg-white border border-[#E6E6E6] flex md:items-center xl:items-start xl:justify-start flex-row md:flex-col xl:flex-row md:justify-center gap-2 overflow-hidden"
      style={{
        boxShadow: "7px 7px 9.5px 0px #0000000D",
      }}
      onClick={() => handleOpen({ label, icon, value, tabColor, model_value })}
    >
      <div className="flex justify-center">
        <div
          className="rounded-full min-w-11 min-h-11 max-w-11 max-h-11 flex items-center justify-center"
          style={{
            backgroundColor: tabColor,
          }}
        >
          {icon}
        </div>
      </div>
      <div>
        <p className="text-[16px] font-[500] text-[#6C6A6ACC] md:text-center xl:text-start">
          {label}
        </p>
        <div>
          <p
            className="text-[12px] md:text-[16px] font-[500] font-[Lato] text-[#6C6A6A] md:text-center xl:text-start"
            style={{
              wordBreak: "break-word",
              hyphens: "auto",
              overflowWrap: "break-word",
            }}
          >
            {value}...
            <span
          // onClick={() =>
          //   handleOpen({ label, icon, value, tabColor, model_value })
          // }
          className="cursor-pointer mt-2 text-[12px] text-[#15AAFC] font-[Lato] font-[500]"
        >
        SEE MORE
        </span>
          </p>
        </div>
        
      </div>
    </div>
  );
  // Original layout (non-dashboard)
  return (
    <div className="p-6 bg-[linear-gradient(150deg,_#0771EF_12.89%,_#15AAFC_85.22%)] rounded-lg mt-6">
      {/* First Row - 3 cards */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-5 mb-3">
        {nutrientData
          .slice(0, 3)
          .map(({ label, icon, value, tabColor, model_value }, index) => (
            <Card
              key={index}
              label={label}
              icon={icon}
              value={value}
              tabColor={tabColor}
              model_value={model_value}
            />
          ))}
      </div>

      {/* Second Row - 2 cards centered */}
      <div className="flex justify-center w-full md:w-auto ">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 w-full md:max-w-4xl">
          {nutrientData
            .slice(3)
            .map(({ label, icon, value, tabColor, model_value }, index) => (
              <Card
                key={index + 3}
                label={label}
                icon={icon}
                value={value}
                tabColor={tabColor}
                model_value={model_value}
              />
            ))}
        </div>
      </div>
      <CardDetailsModal open={open} setOpen={setOpen} data={data} />
    </div>
  );
};

// const DashboardCard = ({ label, icon, value, tabColor }) => (
//   <div
//     className="py-5 px-2 rounded-[17px] bg-white border border-[#E6E6E6] flex items-center flex-col justify-center gap-2 overflow-hidden"
//     style={{
//       boxShadow: "7px 7px 9.5px 0px #0000000D",
//     }}
//   >
//     <div className="flex justify-center">
//       <div
//         className="rounded-full min-w-11 min-h-11 max-w-11 max-h-11 flex items-center justify-center"
//         style={{
//           backgroundColor: tabColor,
//         }}
//       >
//         {icon}
//       </div>
//     </div>
//     <div>
//       <p className="text-[12px] md:text-[16px] font-[500] text-[#6C6A6ACC] text-center ">
//         {label}
//       </p>
//       <div>
//         <p
//           className="text-[12px] md:text-[16px] font-[500] font-[Lato] text-[#6C6A6A] text-center "
//           style={{
//             wordBreak: "break-word",
//             hyphens: "auto",
//             overflowWrap: "break-word",
//           }}
//         >
//           {value}
//         </p>
//       </div>
//     </div>
//   </div>
// );

export default SleepCoachCardView;
